import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import CopyClipboardButton from "components/util/helpers/CopyClipboardButton";
import { Modal } from "seed/helpers"
import { APP_URL } from "settings";
import l from "components/util/l";
import AccessForm from "components/presentation/forms/collaboration/AccessForm";
import SharedPersonItem from "components/presentation/forms/collaboration/Collaboration.sub.Item.view";
import "styles/css/presentation/Collaboration.css";

const CollaborationView = ({
  flow,
  url,
  participants,
  roleOptions,
  onCompleteAccess,
  isAccessModelOpen,
  onChangeParticipantRole,
  onClickChangeOrganizationParticipantRole,
  onClickRemoveParticipant,
  onOpenAccessModel,
  onCloseAccessModel
}) => (
  <>
    <div className="card w-100 h-100">

      <div className="card-header">
        <h3 className="card-header-title">{l("Accesos%GA102")}</h3>
      </div>

      <div className="card-body pt-3 pb-4 px-5 overflow-auto">

        <div className="row h-100">
          <div className="col-md-8 h-100 w-100 overflow-auto">
            <div id="collaboration-access-container" className="h-100 w-100 px-2 py-2">

              <SharedPersonItem
                roleOptions={roleOptions}
                isOwner={true}
                owner={flow?.user}
              />

              {participants.map((participant, idx) => (
                <SharedPersonItem
                  key={idx}
                  participant={participant}
                  roleOptions={roleOptions}
                  owner={flow?.user}
                  onChangeParticipantRole={onChangeParticipantRole}
                  onClickChangeOrganizationParticipantRole={onClickChangeOrganizationParticipantRole}
                  onClickRemoveParticipant={onClickRemoveParticipant}
                />
              ))}

              <div className="mt-4">
                <button className="btn btn-primary float-right" onClick={onOpenAccessModel}>
                  <i class="fas fa-plus mr-1"></i> {l("Crear acceso%PA021")}
                </button>
              </div>
            </div>
          </div>

          <div className="col-md-3 py-2 h-100 w-100 border-left">

            <div id="collaboration-share-container" className="mx-3">


              <div className="pb-1">
                <div className="alert alert-soft-success" role="alert">
                  <div className="px-1 py-2">
                    <QRCodeCanvas value={"wa.me/17752641511"} size={170} bgColor="#fff" marginSize={2} />
                  </div>

                  {l("Utiliza Workix desde Whatsapp, enviando mensaje al número.%PA033")}<br />
                  <a className="btn btn-success btn-sm btn-block mt-2"
                    href="https://wa.me/17752641511" target="_blank"
                    rel="noopener noreferrer">
                    <i className="fab fa-whatsapp mr-1"></i>+1 (775) 264-1511
                  </a>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
    {isAccessModelOpen && (
      <Modal
        width={550}
        height={500}
        flowId={flow.id}
        roleOptions={roleOptions}
        onCompleteAccess={onCompleteAccess}
        component={AccessForm}
        onClose={onCloseAccessModel}
      />
    )}
  </>
);

export default CollaborationView;